import { createAction, props } from '@ngrx/store';
import { RedirectionData } from '../types';

export const RegisterHandlerAction = createAction('[Redirection] register handler', props<{ destination: string }>());

export const ResetRedirectionAction = createAction('[Redirection] reset');

export const InitiateRedirection = createAction(
  '[Redirection] initiate',
  props<{ redirectionParams: { [key: string]: any } }>()
);

export const RedirectionAction = createAction(
  '[Redirection] redirect',
  props<{ destination: string; redirectionData: RedirectionData }>()
);

export const RedirectionFailedAction = createAction(
  '[Redirection] failed',
  props<{ destination: string; redirectionData: RedirectionData }>()
);
